export default function AndroidTrain() {
  return (
    <div
      className="ion-icon-android-train"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g id="Icon_35_">
	<g>
		<g>
			<path d="M80,346.666c0,41.604,33.062,74.666,74.667,74.666L128,448v16h256v-16l-26.667-26.668
				c41.604,0,74.667-33.062,74.667-74.666V133.334C432,58.668,349.864,48,256,48S80,58.668,80,133.334V346.666z M256,376
				c-22.002,0-40-17.997-40-39.999S233.998,296,256,296s40,17.999,40,40.001S278.002,376,256,376z M384,224H128v-96h256V224z"/>
		</g>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
